import React, { useEffect, useState } from "react";
import {
  Tabs,
  Card,
  Row,
  Col,
  Dropdown,
  Menu,
  Grid,
  Table,
  Select,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import "./dashboard.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { useFindAllVoucherFinanaceApprovalStatusMutation, useGetAllPartiesMutation } from "../../redux-toolkit/services/voucherFinanceService";
import { useDispatch, useSelector } from "react-redux";
import { getApprovalStatusListWithAll, getPartyListWithAll, setApprovalStatusList, setPartyList } from "../../redux-toolkit/slices/voucherFinanceSlice";
import { alertMessage } from "../../utils/AlertService";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useGetAllPurposeCodesMutation } from "../../redux-toolkit/services/voucherKarmaService";
import { getPurposeCodesWithAll, setPurposeCodes } from "../../redux-toolkit/slices/voucherKarmaSlice";
import { useFindAllPartyCategoryMasterMutation } from "../../redux-toolkit/services/partyCategoryMasterService";
import { getPartyCategoryMasterListWithAll, setAllPartyCategoryMaster } from "../../redux-toolkit/slices/partyCategoryMasterSlice";
import { getDashboardFinancialStatements, getDashboardPartyCategory, getDashboardPurpose, getDashboardReligion, getDashboardScriptureReferences, getDashboardSummary, getDashboardTables, getDashboardTrend, setDashboardData } from "../../redux-toolkit/slices/dashbordSlice";
import { useExportDashboardTablesMutation, useExportFinancialStatementsMutation, useExportScriptureReferencesMutation, useGetDashboardDataMutation } from "../../redux-toolkit/services/dashboardService";
import { useGetAllVoucherTypeFinanceMasterListMutation } from "../../redux-toolkit/services/voucherTypeFinanceMasterService";
import { getVoucherTypeMasterListWithAll, setAllVoucherTypeFinanceMaster } from "../../redux-toolkit/slices/voucherTypeFinanceMasterSlice";
import { useGetAllReligionsMutation } from "../../redux-toolkit/services/scenarioMasterService";
import { getReligionsWithAll, setReligions } from "../../redux-toolkit/slices/scenarioMasterSlice";
import Loading from "../Loading";
import { Button } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";


const { useBreakpoint } = Grid;

export default function KarmicDashboard() {
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const localUserObj: any = getLocalStorageData("localUser");

  const [findAllVoucherFinanaceApprovalStatus, findAllVoucherFinanaceApprovalStatusResponse] = useFindAllVoucherFinanaceApprovalStatusMutation();
  const [fetchReligions, fetchReligionsResponse] = useGetAllReligionsMutation();
  const [fetchPurposeCodes, fetchPurposeCodesResponse] = useGetAllPurposeCodesMutation();
  const [findAllPartyCategoryMaster, findAllPartyCategoryMasterResponse] = useFindAllPartyCategoryMasterMutation()
  const [fetchDashboard, fetchDashboardResponse] = useGetDashboardDataMutation();
  const [fetchVoucherTypeFinanceMaster, fetchVoucherTypeFinanceMasterResponse] = useGetAllVoucherTypeFinanceMasterListMutation();
  const [fetchAllParties, fetchAllPartiesResponse] = useGetAllPartiesMutation();
  const [exportDashboardTables, exportDashboardTablesResponse] = useExportDashboardTablesMutation();
  const [exportScriptureReferences, exportScriptureReferencesResponse] = useExportScriptureReferencesMutation();
  const [exportFinancialStatements, exportFinancialStatementsResponse] = useExportFinancialStatementsMutation();


  const [selectedTab, setSelectedTab] = useState("Trend");
  const [religion, setReligion] = useState("All");
  const [category, setCategory] = useState<number>(0);
  const [purpose, setPurpose] = useState("All");
  const [frequency, setFrequency] = useState("daily");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [party, setParty] = useState("All");
  const [voucherType, setVoucherType] = useState("All");


  const statuses = useSelector(getApprovalStatusListWithAll);
  const religions = useSelector(getReligionsWithAll);
  const purposeCodes = useSelector(getPurposeCodesWithAll);
  const partyCategories = useSelector(getPartyCategoryMasterListWithAll);
  const dashboardSummary = useSelector(getDashboardSummary);
  const dashboardTrend: any = useSelector(getDashboardTrend);
  const religionData = useSelector(getDashboardReligion) || [];
  const partyCategoryData = useSelector(getDashboardPartyCategory) || [];
  const purposeData = useSelector(getDashboardPurpose);
  const voucherTypes = useSelector(getVoucherTypeMasterListWithAll);
  const parties = useSelector(getPartyListWithAll);
  const dashboardTables = useSelector(getDashboardTables);
  const scriptureReferences = useSelector(getDashboardScriptureReferences);
  const financialStatements = useSelector(getDashboardFinancialStatements);


  const categories = dashboardTrend?.map((t: any) => t.label) || [];
  const creditData = dashboardTrend?.map((t: any) => t.credit) || [];
  const debitData = dashboardTrend?.map((t: any) => t.debit) || [];


  const chartOptions: ApexOptions = {
    chart: {
      id: "karmic-trend",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
      },
      zoom: { enabled: false },
    },
    xaxis: { categories },
    stroke: { curve: "smooth", width: 3 },
    markers: { size: 5 },
    colors: ["#28a745", "#dc3545"],
    legend: { position: "top" },
  };


  const chartSeries = [
    { name: "Credits", data: creditData },
    { name: "Debits", data: debitData },
  ];

  const menuItems = [
    { label: "Trend", key: "Trend" },
    { label: "Religion", key: "Religion" },
    { label: "Party Category", key: "PartyCategory" },
    { label: "Purpose", key: "PurposeCode" },
    { label: "Tables", key: "Tables" },
    { label: "Scripture References", key: "ScriptureReferences" },
    { label: "Financial Statements", key: "FinancialStatements" },
  ];

  const menu = (
    <Menu onClick={(e) => setSelectedTab(e.key)} items={menuItems} />
  );


  const religionLabels = religionData && religionData?.map((r: any) => r.labels);
  const religionSeries = religionData && religionData?.map((r: any) => r.dataCount);


  const religionOptions: ApexOptions = {
    chart: {
      type: "pie",
      toolbar: {
        show: true,
        tools: {
          download: true,
        },
        export: {
          png: { filename: "ReligionData" },
          svg: { filename: "ReligionData" },
          csv: { filename: "ReligionData" },
        },
      },
    },
    labels: religionLabels,
    colors: ["#FFA500", "#0000FF", "#FFD700", "#28a745", "#dc3545"],
    legend: { position: "top" },
  };

  const summaryCards = [
    { title: "Total Credits", value: `₹${dashboardSummary?.totalCredits ?? 0}`, color: "text-success" },
    { title: "Total Debits", value: `₹${dashboardSummary?.totalDebits ?? 0}`, color: "text-danger" },
    { title: "Net Karma", value: `₹${dashboardSummary?.netKarma ?? 0}`, color: "text-primary" },
    { title: "Total Tokens", value: `${dashboardSummary?.totalTokens ?? 0}`, color: "text-dark" },
    {
      title: "Avg AI Confidence",
      value: `${((dashboardSummary?.avgAiConfidence || 0) * 100).toFixed(2)}%`,
      color: "text-warning"
    },
  ];



  const partyCategoriesValues: any = partyCategoryData && partyCategoryData?.map((item: any) => item.label);
  const credits = partyCategoryData && partyCategoryData?.map((item: any) => item.credit);
  const debits = partyCategoryData && partyCategoryData?.map((item: any) => item.debit);


  const partyCategorySeries = [
    { name: "Credits", data: credits },
    { name: "Debits", data: debits },
  ];


  const partyCategoryOptions: ApexOptions = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
        export: {
          png: { filename: "PartyCategoryAnalysis" },
          svg: { filename: "PartyCategoryAnalysis" },
          csv: { filename: "PartyCategoryAnalysis" },
        },
      },
    },
    plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
    xaxis: { categories: partyCategoriesValues },
    legend: { position: "top" },
    colors: ["#28a745", "#dc3545"],
  };

  const purposeLabels = purposeData && purposeData?.map((item: any) => item.label) || [];
  const purposeCredits = purposeData && purposeData?.map((item: any) => item.credit) || [];
  const purposeDebits = purposeData && purposeData?.map((item: any) => item.debit) || [];

  const purposeSeries = [
    { name: "Credits", data: purposeCredits },
    { name: "Debits", data: purposeDebits },
  ];


  const purposeOptions: ApexOptions = {
    chart: {
      type: "bar",
      stacked: false,
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true,
        },
        export: {
          png: { filename: "PurposeAnalysis" },
          svg: { filename: "PurposeAnalysis" },
          csv: { filename: "PurposeAnalysis" },
        },
      },
    },
    plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
    xaxis: { categories: purposeLabels },
    legend: { position: "top" },
    colors: ["#28a745", "#dc3545"],
  };




  const positiveColumns = [
    { title: "Voucher ID", dataIndex: "voucherId", key: "voucherId" },
    { title: "Agent", dataIndex: "agent", key: "agent" },
    {
      title: "Credit", dataIndex: "credit", key: "credit",
      render: (val: any) => val ? `₹${val}` : "₹0"
    },
    { title: "Purpose", dataIndex: "purpose", key: "purpose" },
    { title: "Religion", dataIndex: "religion", key: "religion" },
  ];

  const negativeColumns = [
    { title: "Voucher ID", dataIndex: "voucherId", key: "voucherId" },
    { title: "Agent", dataIndex: "agent", key: "agent" },
    {
      title: "Debit", dataIndex: "debit", key: "debit",
      render: (val: any) => val ? `₹${val}` : "₹0"
    },
    { title: "Purpose", dataIndex: "purpose", key: "purpose" },
    { title: "Religion", dataIndex: "religion", key: "religion" },
  ];


  const scriptureColumns = [
    { title: "Voucher ID", dataIndex: "voucherId", key: "voucherId" },
    { title: "Scripture", dataIndex: "scripture", key: "scripture" },
    { title: "Reference Code", dataIndex: "referenceCode", key: "referenceCode" },
    { title: "Outcome", dataIndex: "outcome", key: "outcome" },
  ];


  const assetColumns = [
    { title: "Account", dataIndex: "accountName", key: "accountName" },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => `₹${val}`,
    },
  ];

  const liabilityColumns = [
    { title: "Account", dataIndex: "accountName", key: "accountName" },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => `₹${val}`,
    },
  ];

  const incomeColumns = [
    { title: "Account", dataIndex: "accountName", key: "accountName" },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => `₹${val}`,
    },
  ];

  const expenseColumns = [
    { title: "Account", dataIndex: "accountName", key: "accountName" },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (val: number) => `₹${val}`,
    },
  ];



  useEffect(() => {
    findAllVoucherFinanaceApprovalStatus({
      token: localUserObj?.token,
    });
  }, [findAllVoucherFinanaceApprovalStatus]);

  useEffect(() => {
    if (findAllVoucherFinanaceApprovalStatusResponse.isSuccess) {
      dispatch(setApprovalStatusList(findAllVoucherFinanaceApprovalStatusResponse));
    } else if (findAllVoucherFinanaceApprovalStatusResponse.isError) {
      let response: any = findAllVoucherFinanaceApprovalStatusResponse.error;
      alertMessage(response, "error");
    }
  }, [
    findAllVoucherFinanaceApprovalStatusResponse.isSuccess,
    findAllVoucherFinanaceApprovalStatusResponse.isError,
  ]);


  useEffect(() => {
    fetchReligions({ token: localUserObj?.token });
  }, []);

  useEffect(() => {
    if (fetchReligionsResponse.isSuccess) {
      dispatch(setReligions(fetchReligionsResponse));
    } else if (fetchReligionsResponse.isError) {
      let response: any = fetchReligionsResponse.error;
      alertMessage(response, "error");
    }
  }, [fetchReligionsResponse.isSuccess, fetchReligionsResponse.isError]);

  useEffect(() => {
    fetchPurposeCodes({ token: localUserObj?.token });
  }, []);

  useEffect(() => {
    if (fetchPurposeCodesResponse.isSuccess) {
      dispatch(setPurposeCodes(fetchPurposeCodesResponse));
    } else if (fetchPurposeCodesResponse.isError) {
      let response: any = fetchPurposeCodesResponse.error;
      alertMessage(response, "error");
    }
  }, [fetchPurposeCodesResponse.isSuccess, fetchPurposeCodesResponse.isError]);

  useEffect(() => {
    findAllPartyCategoryMaster({ token: localUserObj?.token });
  }, []);


  useEffect(() => {
    if (findAllPartyCategoryMasterResponse.isSuccess) {
      dispatch(setAllPartyCategoryMaster(findAllPartyCategoryMasterResponse));
    } else if (findAllPartyCategoryMasterResponse.isError) {
      let response: any = findAllPartyCategoryMasterResponse.error;
      alertMessage(response, "error");
    }
  }, [findAllPartyCategoryMasterResponse.isSuccess, findAllPartyCategoryMasterResponse.isError]);

  useEffect(() => {
    fetchVoucherTypeFinanceMaster({ token: localUserObj?.token });
  }, []);


  useEffect(() => {
    if (fetchVoucherTypeFinanceMasterResponse.isSuccess) {
      dispatch(setAllVoucherTypeFinanceMaster(fetchVoucherTypeFinanceMasterResponse));
    } else if (fetchVoucherTypeFinanceMasterResponse.isError) {
      let response: any = fetchVoucherTypeFinanceMasterResponse.error;
      alertMessage(response, "error");
    }
  }, [fetchVoucherTypeFinanceMasterResponse.isSuccess, fetchVoucherTypeFinanceMasterResponse.isError]);

  useEffect(() => {
    fetchAllParties({ token: localUserObj?.token });
  }, []);

  useEffect(() => {
    if (fetchAllPartiesResponse.isSuccess) {
      dispatch(setPartyList(fetchAllPartiesResponse));
    } else if (fetchAllPartiesResponse.isError) {
      let response: any = fetchAllPartiesResponse.error;
      alertMessage(response, "error");
    }
  }, [fetchAllPartiesResponse.isSuccess, fetchAllPartiesResponse.isError]);



  useEffect(() => {
    const payload = {
      flag: selectedTab,
      religionName: religion === "All" ? null : religion,
      partyCategoryId: category == 0 ? null : category,
      voucherTypeId: voucherType === "All" ? null : voucherType,
      party: party === "All" ? null : party,
      purposeCode: purpose === "All" ? null : purpose,
      approvalStatus: selectedStatus === "All" ? null : selectedStatus,
      dateGrain: frequency,
    };

    fetchDashboard({
      token: localUserObj?.token,
      payload,
    });
  }, [religion, category, purpose, frequency, selectedStatus, selectedTab]);

  useEffect(() => {
    if (fetchDashboardResponse.isSuccess) {
      dispatch(setDashboardData(fetchDashboardResponse.data));
    }
  }, [fetchDashboardResponse.isSuccess]);



  const handleExportTables = async () => {
    const payload = {
      flag: selectedTab,
      religionName: religion === "All" ? null : religion,
      partyCategoryId: category === 0 ? null : category,
      voucherTypeId: voucherType === "All" ? null : voucherType,
      party: party === "All" ? null : party,
      purposeCode: purpose === "All" ? null : purpose,
      approvalStatus: selectedStatus === "All" ? null : selectedStatus,
      dateGrain: frequency,
    };
    exportDashboardTables({
      token: localUserObj?.token,
      payload,
    });
  };


  const handleExportScriptureReferences = async () => {
    const payload = {
      flag: selectedTab,
      religionName: religion === "All" ? null : religion,
      partyCategoryId: category === 0 ? null : category,
      voucherTypeId: voucherType === "All" ? null : voucherType,
      party: party === "All" ? null : party,
      purposeCode: purpose === "All" ? null : purpose,
      approvalStatus: selectedStatus === "All" ? null : selectedStatus,
      dateGrain: frequency,
    };
    exportScriptureReferences({
      token: localUserObj?.token,
      payload,
    });
  };


  const handleExportFinancialStatements = async () => {
    const payload = {
      flag: selectedTab,
      religionName: religion === "All" ? null : religion,
      partyCategoryId: category === 0 ? null : category,
      voucherTypeId: voucherType === "All" ? null : voucherType,
      party: party === "All" ? null : party,
      purposeCode: purpose === "All" ? null : purpose,
      approvalStatus: selectedStatus === "All" ? null : selectedStatus,
      dateGrain: frequency,
    };
    exportFinancialStatements({
      token: localUserObj?.token,
      payload,
    });
  };


  useEffect(() => {
    if (exportDashboardTablesResponse.isSuccess) {
      alertMessage("Dashboard Tables Excel export downloaded successfully", "success");
    } else if (exportDashboardTablesResponse.isError) {
      alertMessage("Failed to export Dashboard Tables", "error");
    }
  }, [exportDashboardTablesResponse.isSuccess, exportDashboardTablesResponse.isError]);

  useEffect(() => {
    if (exportScriptureReferencesResponse.isSuccess) {
      alertMessage("Scripture References Excel export downloaded successfully", "success");
    } else if (exportScriptureReferencesResponse.isError) {
      alertMessage("Failed to export Scripture References", "error");
    }
  }, [exportScriptureReferencesResponse.isSuccess, exportScriptureReferencesResponse.isError]);

  useEffect(() => {
    if (exportFinancialStatementsResponse.isSuccess) {
      alertMessage("Financial Statements Excel export downloaded successfully", "success");
    } else if (exportFinancialStatementsResponse.isError) {
      alertMessage("Failed to export Financial Statements", "error");
    }
  }, [exportFinancialStatementsResponse.isSuccess, exportFinancialStatementsResponse.isError]);



  return (
    <div className="mt-4">
      <h2 className="mb-4 text-center text-accent">Karmic Accounting Dashboard</h2>

      {findAllVoucherFinanaceApprovalStatusResponse.isLoading ||
        fetchReligionsResponse.isLoading ||
        findAllPartyCategoryMasterResponse.isLoading ||
        fetchDashboardResponse.isLoading ||
        fetchVoucherTypeFinanceMasterResponse.isLoading ||
        fetchAllPartiesResponse.isLoading ||
        exportDashboardTablesResponse.isLoading ||
        exportScriptureReferencesResponse.isLoading ||
        exportFinancialStatementsResponse.isLoading
        ? (
          <Loading />
        ) : null}


      <div className="mb-4 w-full">
        {screens.md ? (
          <Tabs
            activeKey={selectedTab}
            onChange={(key) => setSelectedTab(key)}
            items={menuItems.map((item) => ({
              label: item.label,
              key: item.key,
            }))}
            centered
            className="w-full"
          />
        ) : (
          <select
            className="form-select form-select-sm"
            value={selectedTab}
            onChange={(e) => setSelectedTab(e.target.value)}
          >
            {menuItems.map((item) => (
              <option key={item.key} value={item.key}>
                {item.label}
              </option>
            ))}
          </select>
        )}
      </div>

      <div className="row mt-4 mb-4">
        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Religion</label>
          <select
            className="form-select form-select-sm"
            name="religion"
            value={religion}
            onChange={(e) => setReligion(e.target.value)}
          >
            {religions?.map((r: any) => (
              <option key={r.id} value={r.label}>
                {r.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Party Category</label>
          <select
            className="form-select form-select-sm"
            name="category"
            value={category}
            onChange={(e) => setCategory(Number(e.target.value))}

          >
            {partyCategories?.map((pc: any) => (
              <option key={pc.id} value={pc.id}>
                {pc.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Purpose</label>
          <select
            className="form-select form-select-sm"
            name="purpose"
            value={purpose}
            onChange={(e) => setPurpose(e.target.value)}
          >
            {purposeCodes?.map((p: any) => (
              <option key={p.id} value={p.label}>
                {p.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Approval Status</label>
          <select
            className="form-select form-select-sm"
            name="approvalStatus"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            {statuses?.map((status: any) => (
              <option key={status.id} value={status.label}>
                {status.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Party</label>
          <select
            className="form-select form-select-sm"
            name="party"
            value={party}
            onChange={(e) => setParty(e.target.value)}
          >
            {parties?.map((p: any) => (
              <option key={p.id} value={p.label}>
                {p.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Voucher Type</label>
          <select
            className="form-select form-select-sm"
            name="voucherType"
            value={voucherType}
            onChange={(e) => setVoucherType(e.target.value)}
          >
            {voucherTypes?.map((v: any) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <label className="form-label">Frequency</label>
          <select
            className="form-select form-select-sm"
            name="frequency"
            value={frequency}
            onChange={(e) => setFrequency(e.target.value)}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>
      </div>

      {screens.lg ? (
        <div
          style={{
            display: "flex",
            gap: "16px",
            overflowX: "auto",
            paddingBottom: "10px",
          }}
          className="mb-4"
        >
          {summaryCards.map((card, index) => (
            <Card
              key={index}
              bordered
              hoverable
              className="text-center shadow-sm rounded"
              style={{ minWidth: 180 }}
              bodyStyle={{ padding: "10px 12px" }}
            >
              <h6 style={{ marginBottom: "6px" }}>{card.title}</h6>
              <p className={`fw-bold ${card.color} mb-0`}>{card.value}</p>
            </Card>
          ))}
        </div>
      ) : (
        <Row gutter={[16, 16]} justify="center">
          {summaryCards.map((card, index) => (
            <Col key={index} xs={24} sm={12} md={8}>
              <Card
                bordered
                hoverable
                className="text-center shadow-sm rounded"
                bodyStyle={{ padding: "10px 12px" }}
              >
                <h6 style={{ marginBottom: "6px" }}>{card.title}</h6>
                <p className={`fw-bold ${card.color} mb-0`}>{card.value}</p>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      {selectedTab === "Trend" && (
        <div className="mt-5">
          <h4 className="text-center mb-4">Time Trend ({frequency})</h4>
          {chartSeries && chartSeries.length > 0 && chartSeries[0].data.length > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="line"
              height={350}
            />
          ) : (
            <p className="text-center text-muted">No trend data available</p>
          )}
        </div>
      )}

      {selectedTab === "Religion" && (
        <div className="mt-5">
          <h4 className="text-center mb-4">Religion Distribution</h4>
          {religionSeries && religionSeries.length > 0 ? (
            <Chart
              options={religionOptions}
              series={religionSeries}
              type="pie"
              height={400}
            />
          ) : (
            <p className="text-center text-muted">No religion data available</p>
          )}
        </div>
      )}


      {selectedTab === "PartyCategory" && (
        <div className="mt-5">
          <h4 className="text-center mb-4">Party Category Analysis</h4>
          {partyCategorySeries && partyCategorySeries.length > 0 && partyCategorySeries[0].data.length > 0 ? (
            <Chart
              options={partyCategoryOptions}
              series={partyCategorySeries}
              type="bar"
              height={350}
            />
          ) : (
            <p className="text-center text-muted">No party category data available</p>
          )}
        </div>
      )}
      {selectedTab === "PurposeCode" && (
        <div className="mt-5">
          <h4 className="text-center mb-4">Purpose Analysis</h4>
          {purposeSeries && purposeSeries.length > 0 && purposeSeries[0].data.length > 0 ? (
            <Chart
              options={purposeOptions}
              series={purposeSeries}
              type="bar"
              height={350}
            />
          ) : (
            <p className="text-center text-muted">No purpose data available</p>
          )}
        </div>
      )}

      {selectedTab === "Tables" && (
        <div className="mt-5">
          <div className="d-flex justify-content-end mb-3">
            <Button
              variant="success"
              size="sm"
              className="px-3 py-2 rounded shadow-sm"
              onClick={() => handleExportTables()}
            >
              <FiDownload /> Export to Excel
            </Button>
          </div>

          <h4 className="text-center mb-4">Top Positive Karmic Vouchers</h4>
          <div className="table-responsive mb-4">
            <Table
              bordered
              size="small"
              rowKey="voucherId"
              columns={positiveColumns}
              dataSource={dashboardTables?.topPositiveVouchers || []}
              pagination={false}
              scroll={{ x: true }}
            />
          </div>

          <h4 className="text-center mt-5 mb-4">Top Negative Karmic Vouchers</h4>
          <div className="table-responsive mb-4">
            <Table
              bordered
              size="small"
              rowKey="voucherId"
              columns={negativeColumns}
              dataSource={dashboardTables?.topNegativeVouchers || []}
              pagination={false}
              scroll={{ x: true }}
            />
          </div>
        </div>
      )}

      {selectedTab === "ScriptureReferences" && (
        <div className="mt-5">
          <div className="d-flex justify-content-end mb-3">
            <Button
              variant="success"
              size="sm"
              className="px-3 py-2 rounded shadow-sm"
              onClick={() => handleExportScriptureReferences()}
            >
              <FiDownload /> Export to Excel
            </Button>
          </div>

          <h4 className="text-center mb-4">Scriptural References Log</h4>
          <div className="table-responsive mb-4">
            <Table
              bordered
              size="small"
              rowKey="voucherId"
              columns={scriptureColumns}
              dataSource={scriptureReferences || []}
              pagination={false}
              scroll={{ x: true }}
            />
          </div>
        </div>
      )}

      {selectedTab === "FinancialStatements" && (
        <div className="mt-5">
          <div className="d-flex justify-content-end mb-3">
            <Button
              variant="success"
              size="sm"
              className="px-3 py-2 rounded shadow-sm"
              onClick={() => handleExportFinancialStatements()}
            >
              <FiDownload /> Export to Excel
            </Button>
          </div>

          <h4 className="text-center mb-4">Karmic Balance Sheet</h4>
          <div className="row">
            <div className="col-md-6 mb-3 d-flex flex-column">
              <h6>Assets (Good Deeds)</h6>
              <div className="flex-grow-1">
                <Table
                  bordered
                  size="small"
                  rowKey="accountName"
                  columns={assetColumns}
                  dataSource={financialStatements?.balanceSheet?.assets || []}
                  pagination={false}
                  locale={{ emptyText: "No records available" }}
                />
              </div>
              <p className="fw-bold mt-2 text-center">
                Total Assets: ₹{financialStatements?.balanceSheet?.totalAssets ?? 0}
              </p>
            </div>

            <div className="col-md-6 mb-3 d-flex flex-column">
              <h6>Liabilities (Bad Deeds)</h6>
              <div className="flex-grow-1">
                <Table
                  bordered
                  size="small"
                  rowKey="accountName"
                  columns={liabilityColumns}
                  dataSource={financialStatements?.balanceSheet?.liabilities || []}
                  pagination={false}
                  locale={{ emptyText: "No records available" }}
                />
              </div>
              <p className="fw-bold mt-2 text-center">
                Total Liabilities: ₹{financialStatements?.balanceSheet?.totalLiabilities ?? 0}
              </p>
            </div>
          </div>

          <h4 className="text-center mt-5 mb-4">Karmic Profit & Loss Statement</h4>
          <div className="row">
            <div className="col-md-6 mb-3 d-flex flex-column">
              <h6>Income (Merit)</h6>
              <div className="flex-grow-1">
                <Table
                  bordered
                  size="small"
                  rowKey="accountName"
                  columns={incomeColumns}
                  dataSource={financialStatements?.profitLoss?.income || []}
                  pagination={false}
                  locale={{ emptyText: "No records available" }}
                />
              </div>
              <p className="fw-bold mt-2 text-center">
                Total Income: ₹{financialStatements?.profitLoss?.totalIncome ?? 0}
              </p>
            </div>

            <div className="col-md-6 mb-3 d-flex flex-column">
              <h6>Expenses (Demerit)</h6>
              <div className="flex-grow-1">
                <Table
                  bordered
                  size="small"
                  rowKey="accountName"
                  columns={expenseColumns}
                  dataSource={financialStatements?.profitLoss?.expenses || []}
                  pagination={false}
                  locale={{ emptyText: "No records available" }}
                />
              </div>
              <p className="fw-bold mt-2 text-center">
                Total Expenses: ₹{financialStatements?.profitLoss?.totalExpenses ?? 0}
              </p>
            </div>
          </div>

          <h5 className="text-center mt-4">
            Net Profit: ₹{financialStatements?.profitLoss?.netProfit ?? 0}
          </h5>
        </div>
      )}


    </div>
  );
}


